<template>
	<div class="heading-container" :class="[backgroundVariant]">
		<div class="heading-container__content">
			<div class="heading-container__content-text">
				<span class="heading-container__content-title">
					{{ title }}
				</span>
				<span class="heading-container__content-subheading">
					{{ subHeadingText }}
				</span>
			</div>
			<div class="heading-container__content-icon" v-if="showIcone">
				<i :class="['icon', iconClassName]"></i>
			</div>
		</div>
		<Divider v-if="showDivider" class="section-header__divider" />
	</div>
</template>

<script>
import Divider from '@/components/shells/divider/divider';
export default {
	components: { Divider },
	props: {
		title: {
			type: String,
			required: true
		},
		subHeadingText: {
			type: String,
			default: ''
		},
		state: {
			type: String,
			default: 'info'
		},
		variant: {
			type: String,
			default: 'large'
		},
		showIcone: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		backgroundVariant() {
			if (this.variant !== 'medium') {
				return `heading-container--${this.variant}`;
			}
			return `heading-container--medium`;
		},
		showDivider() {
			return this.variant === 'large' || this.variant === 'small';
		},
		iconClassName() {
			return `icon-${this.state}`;
		}
	}
};
</script>

<style lang="scss" scoped>
.heading-container {
	width: 100%;

	&__content {
		display: flex;
		justify-content: space-between;
		&-text {
			display: flex;
			flex-direction: column;
			gap: $gutter-sm;
		}
		&-title {
			font-weight: $medium-font-weight;
			font-size: $heading-font-size-lg;
		}
		&-subheading {
			font-size: $heading-font-size-sm;
		}
		&__icon {
			display: inline-flex;
			justify-content: center;
			align-items: center;
			font-size: $heading-font-size-lg;
		}
	}
	.section-header__divider {
		width: 100%; //overriding component styles for desired styling of heading
	}
}
.heading-container--large {
	.section-header__divider {
		margin-block-end: revert; //overriding component styles for desired styling of heading
	}
}
.heading-container--small {
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	gap: $gutter-lg;
	.heading-container__content {
		&-text {
			gap: 0;
		}
		&-title {
			font-weight: $medium-font-weight;
			text-transform: uppercase;
			font-size: $heading-font-size-sm;
			color: $neutral-2;
		}
	}
}
.heading-container--medium {
	padding: $padding-sm;
	background-color: $base-tint;
	.heading-container__content {
		&-text {
			display: flex;
			flex-direction: column;
		}
		&-title {
			font-weight: $medium-font-weight;
			font-size: $heading-font-size-md;
			font-family: $secondary-font-family;
		}
		&-subheading {
			font-size: $heading-font-size-sm;
		}
	}
}
</style>
